<template>
  <header class="header-block">
    <a href="https://vip.sohu.com" target="_blank"><span class="logo logo-vip"></span></a>
    <a href="https://mail.sohu.com" target="_blank"><span class="logo logo-free"></span></a>
    <a href="javascript: location.reload();"><span class="logo logo-help"></span></a>

    <div class="wrap-search" v-if="showSearch">
      <input
        type="search"
        name="searchKey"
        placeholder="搜索"
        class="input-search"
        :value="searchKey"
        @input="$emit('input', $event.target.value)">
    </div>
    
    <ul class="menu">
      <li><a href="//mail.sohu.com/" target="_blank">搜狐免费邮箱</a></li>
      <li><a href="javascript: location.reload();">使用帮助</a></li>
      <li class="customer-service">
        客户服务
        <div class="tip">
          <!-- <p>客服电话：010-58103760</p><br> --><p>客服邮箱：webmaster@vip.sohu.com</p>
        </div>
      </li>
    </ul>
  </header>
</template>

<script>
export default {
  props: [
    'showSearch',
    'searchKey'
  ]
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.header-block {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  border-bottom: 1px solid #D0D0D0;

  .logo{
    display: inline-block;
    width: 130px;
    height: 40px;
    margin-left: 40px;
    margin-top: 10px;
    background-size: 100%;
  }

  .logo-vip {
    background-image: url('../../../assets/image/logo-vip.png');
  }

  .logo-free {
    background-image: url('../../../assets/image/logo-free.png');
  }

  .logo-help {
    background-image: url('../../../assets/image/logo-help.png');
  }

  .tip {
    line-height: 12px;
    z-index: 99;
    width: 280px;
    margin: 0;
    padding: 16px;
    height: 70px;
    position: absolute;
    bottom: -70px;
    right: 0;
    cursor: default;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #d0d0d0;
    display: none;

    > p {
      margin: 0;
      font-size: 13px;
    }

    &::after {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      top: -11px;
      right: 20px;
      transform: rotate(135deg);
      background-color: white;
      border: 1px solid #d0d0d0;
      border-right: 0;
      border-top: 0;
    }
  }


  .menu {
    font-size: 15px;
    font-family: PingFangSC-Regular;
    color: rgba(50, 50, 55, 1);
    line-height: 60px;
    height: 60px;
    margin-right: 28px;
    float: right;
    cursor: pointer;
    li {
      position: relative;
      display: inline-block;
      margin: 0 12px;

      &:not(:last-child):after {
        content: "";
        position: absolute;
        width: 1px;
        height: 14px;
        right: -14px;
        top: 50%;
        margin-top: -7px;
        background-color: rgba(50, 50, 55, 1);
      }
    }
  }
}

.customer-service:hover {
  .tip {
    display: block;
  }
}

.header-title {
  height: 50px;
  background: linear-gradient(90deg, rgba(237, 187, 77, 1), $dark-yellow-color);
  font-size: 22px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 50px;
  text-shadow: 0 1px 5px #9c4509;
}

.wrap-search {
  margin-left: 40px;
  display: inline-block;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  vertical-align: top;
}

.input-search {
  position: relative;
  padding: 0 42px;
  width: 460px;
  height: 32px;
  line-height: 60px;
  vertical-align: middle;
  border: none;
  background: #F3F3F3;
  border-radius: 4px;

  &::before {
    content: '';
    position: absolute;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/help/components/header.vue